export default __webpack_public_path__ + "static/media/electric-vehicle.ac299fdb.svg";